module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-Australia-Website.9119fa35.jpg";